import { ChangeEvent, FC } from 'react';
import { Buttons, Form, FormElements } from '../../../common/AddEditFormLayout/AddEditFormLayout.styles';
import { DropdownWrapperLarge, DropdownWrapperMedium, InputWrapperLarge } from '../../../common/FormElementWrappers/FormElementWrappers.styles';
import Header from '../../../common/Header/Header';
import Button from '../../../components/Button/Button';
import Dropdown from '../../../components/Dropdown/Dropdown';
import Input from '../../../components/Input/Input';
import { OPTIONS_PLACEHOLDER } from '../../../constants/Dropdown';
import { RowWrapper } from './UserForm.styles';
import { UserFormProps } from './UserForm.types';

const UserForm: FC<UserFormProps> = ({
  headerTitle,
  formValues,
  formErrors,
  setFormErrors,
  setFormValues,
  handleSave,
  saveDisabled,
  isButtonLoading,
}) => {
  const handleDropDown = (event: ChangeEvent<HTMLSelectElement>) => {
    setFormValues({ ...formValues, [event.target.id]: event.target.value });
    setFormErrors && setFormErrors({...formErrors, [event.target.id]: ''})
  };

  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    setFormValues({ ...formValues, [event.target.id]: event.target.value });
    setFormErrors && setFormErrors({...formErrors, [event.target.id]: ''})
  };

  return (
    <>
    <Header breadcrumb={{ label: 'Back to User Table', to: '/tables/users' }} title={headerTitle} />
      <Form>
        <FormElements>
          <RowWrapper>
            <InputWrapperLarge>
              <Input
                label='Full Name'
                id='fullName'
                value={formValues?.fullName}
                onChange={handleInput}
                errorText={formErrors?.fullName}
              />
            </InputWrapperLarge>
            <InputWrapperLarge>
              <Input
                label='LAN ID'
                id='loginId'
                value={formValues?.loginId}
                onChange={handleInput}
                errorText={formErrors?.loginId}
              />
            </InputWrapperLarge>
          </RowWrapper>
          <RowWrapper>
            <DropdownWrapperLarge>
              <Dropdown
                label='Web Access'
                id='webAccess'
                options={[{value:'0', label:'None'}, {value:'10', label:'Reports'}, {value:'20', label:'Full Access'}]}
                value={formValues?.webAccess?.toString() || OPTIONS_PLACEHOLDER}
                errorText={formErrors?.webAccess}
                onChange={handleDropDown}
              />
            </DropdownWrapperLarge>
            <DropdownWrapperMedium>
                <Dropdown 
                    label='Security' 
                    id='security'
                    options={[{value:'1', label:'Admin'}, {value:'2', label:'User'}]}
                    value={formValues?.security?.toString() || OPTIONS_PLACEHOLDER}
                    errorText={formErrors?.security}
                    onChange={handleDropDown}
                />
            </DropdownWrapperMedium>
          </RowWrapper>
        </FormElements>
        <Buttons>
          <Button label='Save' onClick={handleSave} disabled={saveDisabled} isLoading={isButtonLoading} />
        </Buttons>
      </Form>
    </>
  );
};

export default UserForm;
